export default __webpack_public_path__ + "static/identity-lock-481bea8261f9e3103fc336adf9474503.jpg";